import $ from 'jquery';

$( document ).on( 'click', '#open_mobile_nav, #close_mobile_nav', function() {
	$( '.mobile-nav' ).toggleClass( 'active' );
} );
$( document ).on( 'click', '.down-arw', function() {
	$( this ).parent().toggleClass( 'active' );
} );
